
import { defineComponent } from 'vue'
import NavigationItem from './NavigationItem.vue'

export default defineComponent({
  name: 'NavigationItemWrapper',
  components: {
    NavigationItem
  },
  props: {
    children: {
      type: Array,
      default: () => []
    },
    path: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    callBack: {
      type: Function,
      default: () => {
        return null
      }
    }
  }
})
